import { Box, Link, Center, Heading, Flex } from "@chakra-ui/react";
import BaseLayout from "../../components/base_layout";
import { Swiper, SwiperSlide } from "swiper/react";
import SwiperCore, {
  Autoplay,
  Pagination,
  Navigation,
  EffectFade,
} from "swiper";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/scrollbar";
import "swiper/css/effect-fade";
import styles from "../../styles/Home.module.css";
import { GetReviewData } from "../../pages/api/base";
import React, { useState, useEffect } from "react";
import { useRouter } from "next/router";

SwiperCore.use([Autoplay, Pagination, Navigation, EffectFade]);

export default function PolicyPrivacy() {
  const [reviews, setReviews] = useState([]);
  const router = useRouter();
  const handleClick = async () => {
    router.push("/estimate/select");
  };

  async function _getReview() {
    const data = await GetReviewData();
    setReviews(data);
  }

  useEffect(() => {
    _getReview();
  }, []);

  return (
    <BaseLayout>
      <Box>
        <Box>
          <Box className="panda-intro">
            <Box className="panda-intro_wrap_1st">
              <div className="intro_id">
                <Box className="introLeft">
                  <div className="introLeft_ex">
                    <div>
                      <p>우리 회사에 딱 맞는 서비스</p>
                    </div>
                    <h4>
                      전자부품 검색은 <br /> 이제 판다파츠에서
                    </h4>
                    <span>
                      가격비교, 주문, 통관, 배송까지
                      <br /> 자동화된 온라인 서비스를 제공합니다.
                    </span>
                  </div>
                </Box>
                <Box className="introRight">
                  <img src="/images/intro_example/intro3.png" />
                </Box>
              </div>
            </Box>
            <Box className="panda-intro_wrap_2nd">
              <div className="panda-intro_search">
                <Box className="panda-intro_search_wrap">
                  <div className="panda-intro_search_tp">
                    <div>
                      <p>전자부품 가격 비교</p>
                    </div>
                    <h4>단 한번의 검색으로</h4>
                    <span>
                      글로벌 유통사의 실시간 재고와 가격 정보를
                      <br /> 비교하고 안전하게 구매 할 수 있습니다.
                    </span>
                  </div>
                  <div className="panda-intro_search_btm">
                    <ul>
                      <li>
                        <img src="/images/brand/arrow.png" />
                      </li>
                      <li>
                        <img src="/images/brand/dk_real_logo.png" />
                      </li>
                      <li>
                        <img src="/images/brand/mouser.png" />
                      </li>
                      <li>
                        <img src="/images/brand/Element14_2.png" />
                      </li>
                      <li>
                        <img src="/images/brand/veri.png" />
                      </li>
                    </ul>
                    <ul>
                      <li>
                        <img src="/images/brand/one.png" />
                      </li>
                      <li>
                        <img src="/images/brand/df.png" />
                      </li>
                      <li>
                        <img src="/images/brand/06.seed_studio.png" />
                      </li>

                      <li>
                        <img src="/images/brand/logo_pandaparts.png" />
                      </li>
                      <li>
                        <img src="/images/brand/logo_alliance.png" />
                      </li>
                    </ul>
                  </div>
                </Box>
              </div>
            </Box>
            <Box>
              <div className="panda-intro_estimate">
                <Box className="panda-intro_estimate_wrap">
                  <div className="panda-intro_estimate_wrap_ex">
                    <h4>
                      내가 찾는 전자부품을 단 1분이내 <br /> 자동 견적부터
                      구매까지 쉽고 빠르게
                    </h4>
                    <span>
                      판다봇 견적으로 자동 견적 서비스를 경험해 보세요.
                    </span>

                    <Link className={styles.botBtn} onClick={handleClick}>
                      판다봇 견적
                    </Link>
                  </div>
                </Box>
              </div>
            </Box>

            <div className={styles.special}>
              <div className={styles.rowrow}>
                <div className={styles.special_set}>
                  <p className={styles.roundbg}>
                    <p className={styles.center}>
                      <img
                        src="/images/box.png"
                        alt=""
                        width="60px"
                        height="none"
                      ></img>
                    </p>
                  </p>
                  <h5 className={styles.special_font}>신제품 실시간 런칭</h5>
                  <span className={styles.special_subfont}>
                    매일 1~2만개 신규 전자부품이<br></br>등록됩니다.
                  </span>
                </div>
                <div className={styles.special_set}>
                  <p className={styles.roundbg}>
                    <p className={styles.center}>
                      <img
                        src="/images/graphic.png"
                        alt=""
                        width="60px"
                        height="none"
                      ></img>
                    </p>
                  </p>
                  <h5 className={styles.special_font}>OneStop 플랫폼</h5>
                  <span className={styles.special_subfont}>
                    전자부품 글로벌 메타서치로<br></br>한번에 비교, 구매, 결제
                    하세요.
                  </span>
                </div>
                <div className={styles.special_set}>
                  <p className={styles.roundbg}>
                    <p className={styles.center}>
                      <img
                        src="/images/shopping-centre.png"
                        alt=""
                        width="60px"
                        height="none"
                      ></img>{" "}
                    </p>
                  </p>
                  <h5 className={styles.special_font}>정품판매</h5>
                  <span className={styles.special_subfont}>
                    전세계 공식 대리점, 유통사를 통해<br></br>정품 판매(COC
                    발급, REEL 서비스 제공)
                  </span>
                </div>
              </div>
            </div>
            <div className={styles.container}>
              <h3 className={styles.before_aftertext}>
                <Link href="/board/review">판다파츠 이용 후기</Link>
              </h3>
              <div className={styles.review}>
                <span className={styles.review_img}>
                  <img
                    src="/images/bannerbg.png"
                    alt=""
                    width="300px"
                    height="none"
                  ></img>
                </span>
                <div className={styles.review_title}>
                  <Link href="/board/view?type=notice&no=80">
                    <h5 className={styles.review_font}>
                      무료 항공특송으로 빠르게 배송!<br></br>
                      <span className={styles.panda_red1}>
                        고객의 마음으로 바잉부터 배송까지
                      </span>{" "}
                      전 과정을 책임집니다.
                    </h5>
                  </Link>
                </div>
                <Box className={styles.cardset}>
                  <Swiper
                    spaceBetween={30}
                    slidesPerView={3}
                    autoplay={{
                      delay: 2500,
                      disableOnInteraction: false,
                    }}
                  >
                    {reviews.length > 0 &&
                      reviews.map((review) => (
                        <SwiperSlide className={styles.cardbody} w="280px">
                          <Link href="/board/review">
                            <p className={styles.card_text}>
                              {review.is_subject}
                            </p>
                            <div className={styles.author}>
                              <p className={styles.author_id}>{review.mb_id}</p>
                              <p className={styles.review_star}>
                                <img
                                  src="/images/review_star.png"
                                  alt="메인배너"
                                  width="100px"
                                  height="none"
                                ></img>
                              </p>
                            </div>
                          </Link>
                        </SwiperSlide>
                      ))}
                  </Swiper>
                </Box>
              </div>
              <div className={styles.panda_before_after}>
                <h3 className={styles.before_aftertext}>
                  판다파츠 이용 전후 비교
                </h3>
                <div>
                  <table className={styles.tablestyle}>
                    <thead>
                      <tr>
                        <th className={styles.tabletitle}></th>
                        <th className={styles.tabletitle1}>이용 전</th>
                        <th className={styles.table_after}>이용 후</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td className={styles.tabletitle}>전자부품 구매방법</td>
                        <td className={styles.tabletitle}>
                          직접 거래처와 컨텍하여 주문시간 소요 많음<br></br>
                          구매시 거래처별 각각 주문 진행
                        </td>
                        <td className={styles.after_text}>
                          웹/앱에서 언제 어디서나 글로벌 유통사(제조사),
                          대리점을
                          <br></br>한번에 가격 비교 후 구매가능
                        </td>
                      </tr>
                      <tr>
                        <td className={styles.tabletitle}>전자부품 배송비</td>
                        <td className={styles.tabletitle}>
                          유통사(제조사)별 개별 배송비 각각 발생
                        </td>
                        <td className={styles.after_text}>
                          여러 글로벌 유통사(제조사)를 통해서 구매해도 <br></br>
                          한번에 국내 배송비만 발생 <br></br>(5만원 이상시에는
                          무료 배송)
                        </td>
                      </tr>
                      <tr>
                        <td className={styles.tabletitle}>전자부품 매입수량</td>
                        <td className={styles.tabletitle}>
                          소량 구매가 어려움, 높은 단가
                        </td>
                        <td className={styles.after_text}>
                          단 1개도 주문 가능, 전자부품 가격비교를 통해 최적가
                          구매
                        </td>
                      </tr>
                      <tr>
                        <td className={styles.tabletitle}>결제 관리</td>
                        <td className={styles.tabletitle}>
                          해외송금, 입금, 카드 등 개별 관리 및<br></br>추가
                          수수료 발생
                        </td>
                        <td className={styles.after_text}>
                          카드결제, 무통장입금, 네이버페이, 카카오페이,
                          후불결제, 신용결제 등<br></br>국내 모든 결제 수단,
                          방법 이용 가능, 원화 결제
                        </td>
                      </tr>
                      <tr>
                        <td className={styles.tabletitle}>통관 관리</td>
                        <td className={styles.tabletitle}>
                          각각 개별 주문 관리 및 통관 진행
                        </td>
                        <td className={styles.after_text}>
                          무역 전문가 통관 대행, 관세 비용 절감
                        </td>
                      </tr>
                      <tr>
                        <td className={styles.tabletitle}>세금계산서 관리 </td>
                        <td className={styles.tabletitle}>
                          개별 업체마다 영수증, 계산서 수입관리
                        </td>
                        <td className={styles.after_text1}>
                          단 한장으로 간편하게 관리
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </Box>
        </Box>
      </Box>
    </BaseLayout>
  );
}
